// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-redirect').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-redirect/build.source.js
// module id = 284
// module chunks = 5